import { configureStore } from '@reduxjs/toolkit';
import authSlice from './slices/auth';
import onboardingSlice from './slices/onboarding';
import dashboardSlice from './slices/dashboard';
import voiceToSpeechSlice from './slices/v-t-s';
import accessibility from './slices/floating-icons-state';

export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        onboarding: onboardingSlice.reducer,
        dashboard: dashboardSlice.reducer,
        voiceToSpeech: voiceToSpeechSlice.reducer,
        accessibility: accessibility.reducer
    },
    middleware: getDefaultMiddleware => getDefaultMiddleware({ serializableCheck: false })
});

export type AppDispatch = typeof store.dispatch;
export type AppState = ReturnType<typeof store.getState>;
